import React, { useEffect, useState } from "react";
import {
  Layout,
  Input,
  Button,
  Select,
  Typography,
  message,
  Space,
  TableColumnsType,
  Form,
} from "antd";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import dayjs, { Dayjs } from "dayjs";
import { Modal } from "antd";
import "./index.css";
import HeaderOfUserManagement from "../../../assets/img/userManagement1.png";
import {
  PlusOutlined,
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { get, remove } from "../../../utils/apiUtils";
import MemberModal from "../MemberModal";
import { getUserRole } from "../../../hooks/getUserRoles";
import { normalizeRole } from "../../../utils/roles";
import GenericTable from "../../GeneralTable/GenericTable";
import GeneralButton from "../../GeneralButton";
import { sortByCreatedAt } from "../../../utils/sorByCreateAt";

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

interface DataType {
  key: React.Key;
  name: string;
  email: string;
  gender: string;
  location: string;
  languages: string;
  role: string;
  workspaces: string;
  actions: JSX.Element;
}

const data: DataType[] = [
  {
    key: "1",
    name: "Full name",
    email: "user@gmail.com",
    gender: "Female",
    location: "Turkey",
    languages: "Turkish",
    role: "Manager",
    workspaces: "SY-APS",
    actions: <div>Actions here</div>,
  },
  {
    key: "2",
    name: "Full name",
    email: "user@gmail.com",
    gender: "Female",
    location: "Albania",
    languages: "Albanian, Amharic",
    role: "Manager",
    workspaces: "SY-APS",
    actions: <div>Actions here</div>,
  },
];

const rowSelection = {
  onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  getCheckboxProps: (record: DataType) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

function MembersList() {
  const { t } = useTranslation("userManagement");
  const userRole = getUserRole();
  const [selectionType, setSelectionType] = useState<"checkbox">("checkbox");
  const [searchText, setSearchText] = useState<string>("");
  const [filteredData, setFilteredData] = useState<DataType[]>(data);
  const [typeFilter, setTypeFilter] = useState<string>("Type");
  const [dateFilter, setDateFilter] = useState<Dayjs | string>("");
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [translationList, setTranslationList] = useState([]);
  const [translationTypes, setTranslationTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [genders, setGenders] = useState([]);
  const [countries, setCountries] = useState([]);
  const [workspaces, setWorkspaces] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [roles, setRoles] = useState([]);
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState<any>(null);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [selectedLanguage, setSelectedLanguage] = useState<any>(null);
  const [selectedRole, setSelectedRole] = useState<any>(null);
  const [selectedGender, setSelectedGender] = useState<any>(null);
  const [search, setSearch] = useState<string>("");
  const [visible, setVisible] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [currentMemberId, setCurrentMemberId] = useState(null);
  const [modalMode, setModalMode] = useState("create");
  const [errorInResponse, setErrorInResponse] = useState<any>("");
  const [form] = Form.useForm();
  const [, forceUpdate] = useState<any>();

  const columns: TableColumnsType<DataType> = [
    {
      title: t("membersList.columns.name"),
      dataIndex: "name",
      key: "name",
      sorter: (a: DataType, b: DataType) => a.name.localeCompare(b.name),
    },
    {
      title: t("membersList.columns.location"),
      dataIndex: "location",
      key: "location",
      sorter: (a: DataType, b: DataType) =>
        a.location.localeCompare(b.location),
    },
    {
      title: t("membersList.columns.role"),
      dataIndex: "role",
      key: "role",
      sorter: (a: DataType, b: DataType) => a.role.localeCompare(b.role),
    },
    {
      title: t("membersList.columns.workspaces"),
      dataIndex: "workspaces",
      key: "workspaces",
      sorter: (a: DataType, b: DataType) =>
        a.workspaces.localeCompare(b.workspaces),
    },
    {
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <EyeOutlined
            onClick={() => viewMemberDetails(record.key)}
            style={{ fill: "#A072EB", color: "#A072EB" }}
          />
          <EditOutlined
            onClick={() => openModalForEdit(record.key)}
            style={{ fill: "#A072EB", color: "#A072EB" }}
          />
          <DeleteOutlined
            onClick={() => deleteMember(record.key)}
            style={{ fill: "#A072EB", color: "#A072EB" }}
          />
        </Space>
      ),
    },
  ];

  const openModalForEdit = (memberId: any) => {
    setModalMode("edit");
    setCurrentMemberId(memberId);
    setIsModalVisible(true);
  };

  const showModalForCreate = () => {
    setModalMode("create");
    setCurrentMemberId(null);
    setIsModalVisible(true);
  };

  const viewMemberDetails = (memberId: any) => {
    setCurrentMemberId(memberId);
    setModalMode("view");
    setIsModalVisible(true);
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await get<any>("countries/");
        if (response.type === "success") {
          setCountries(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch countries:", error);
        toast.error(t("membersList.messages.loadCountriesError"));
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await get<any>("Users/workspace-roles/");
        console.log("respone in roleS:", response);
        if (response.type === "success") {
          setRoles(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch roles:", error);
        message.error(t("membersList.messages.loadRolesError"));
      }
    };
    fetchRoles();
  }, []);

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const response = await get<any>("get-all-workspaces");
        if (response.type === "success") {
          setWorkspaces(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch workspace:", error);
        message.error(t("membersList.messages.loadWorkspaceError"));
      }
    };
    fetchWorkspaces();
  }, []);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await get<any>("Users/languages/");
        if (response.type === "success") {
          setLanguages(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch languages:", error);
        message.error(t("membersList.messages.loadLanguageError"));
      }
    };
    fetchLanguages();
  }, []);

  useEffect(() => {
    const fetchGenders = async () => {
      try {
        const response = await get<any>("genders");
        if (response.type === "success") {
          setGenders(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch gender:", error);
        message.error(t("membersList.messages.loadGenderError"));
      }
    };
    fetchGenders();
  }, []);

  const filterData = (): void => {
    const lowercasedSearchText = searchText.toLowerCase();
    const filtered = translationList.filter((item: any) => {
      const searchTextMatch = item.projectname
        .toLowerCase()
        .includes(lowercasedSearchText);
      const typeMatch = typeFilter === "Type" || item.type_name === typeFilter;
      const dateMatch =
        !dateFilter || dayjs(item.date).isSame(dayjs(dateFilter), "day");
      return searchTextMatch && typeMatch && dateMatch;
    });
    setFilteredData(filtered);
  };

  const onCreate = (values: any) => {
    console.log("Received values of form: ", values);
    setVisible(false);
  };

  const deleteMember = (id: any) => {
    Modal.confirm({
      title: t("membersList.deleteConfirm.title"),
      content: (
        <>
          <span>{t("membersList.deleteConfirm.content")}</span>
          <br />
          <strong>{t("membersList.deleteConfirm.confirmQuestion")}</strong>
        </>
      ),
      okText: t("membersList.deleteConfirm.okText"),
      okType: "danger",
      cancelText: t("membersList.deleteConfirm.cancelText"),
      className: "delete-member-modal",
      onOk: async () => {
        setLoading(true);
        try {
          const response = await remove(`Users/workspace-members/${id}/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              Accept: "application/json",
            },
          });

          if (response.type === "success") {
            message.success(t("membersList.messages.deleteSuccess"));
            fetchData();
          } else {
            const errorMessage =
              response.data?.response?.data?.message ||
              t("membersList.messages.deleteError");
            message.error(errorMessage);
          }
        } catch (error: any) {
          console.error("Unexpected error:", error);
          message.error(t("membersList.messages.deleteUnexpectedError"));
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const isValidDate = (dateStr: any, format = "MM/DD/YYYY") => {
    return dayjs(dateStr, format).isValid();
  };

  const handleHideFilters = () => {
    setShowFilters(!showFilters);
  };

  const fetchData = async (
    searchTerm = "",
    selectedGender = "",
    selectedCountry = "",
    selectedLanguage = "",
    selectedWorkspace = "",
    selectedRole = ""
  ) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({ skip: "0", limit: "10" });

      if (searchTerm) queryParams.append("name", searchTerm);
      if (selectedGender) queryParams.append("gender_id", selectedGender);
      if (selectedCountry) queryParams.append("country_id", selectedCountry);
      if (selectedLanguage) queryParams.append("language_id", selectedLanguage);
      if (selectedWorkspace)
        queryParams.append("workspace_id", selectedWorkspace);
      if (selectedRole) queryParams.append("role_id", selectedRole);

      const response = await get<any>(`member-list?${queryParams.toString()}`);
      if (response.type === "success") {
        const membersData = sortByCreatedAt(response.data).map(
          (member: any) => ({
            key: member.id,
            name: member.username,
            email: member.email ?? "",
            gender: member.gender ?? "",
            location: member.location ?? "",
            languages: member.languages?.join(", ") ?? "",
            role: member.role ?? "",
            workspaces: member.workspaces?.filter(Boolean).join(", ") ?? "",
            actions: (
              <Space size="middle">
                <EyeOutlined onClick={() => viewMemberDetails(member.id)} />
                <EditOutlined onClick={() => openModalForEdit(member.id)} />
                <DeleteOutlined onClick={() => deleteMember(member.id)} />
              </Space>
            ),
          })
        );

        const uniqueMembers = membersData.filter(
          (member: any, index: any, self: any) =>
            index === self.findIndex((m: any) => m.key === member.key)
        );

        setFilteredData(uniqueMembers);
      } else {
        setErrorInResponse(response?.data?.response?.data.detail);
      }
    } catch (error) {
      message.error(t("membersList.messages.loadMembersError"));
    } finally {
      setLoading(false);
    }
  };

  // 🔁 RELOAD sa herë ndryshon search apo filtrat
  useEffect(() => {
    fetchData(
      search,
      selectedGender,
      selectedCountry,
      selectedLanguage,
      selectedWorkspace,
      selectedRole
    );
  }, [
    search,
    selectedGender,
    selectedCountry,
    selectedLanguage,
    selectedWorkspace,
    selectedRole,
  ]);

  useEffect(() => {
    filterData();
  }, [searchText, typeFilter, dateFilter, translationList]);

  const handleCreate = (values: any) => {
    form.resetFields();
    setIsModalVisible(false);
    fetchData();
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const clearAllFilters = () => {
    setSelectedCountry(null);
    setSelectedWorkspace(null);
    setSelectedRole(null);
    setSearchText("");

    form.resetFields();
    forceUpdate({});

    fetchData();
  };

  return (
    <>
      <div className="user-management-layout" style={{ marginLeft: 0 }}>
        <Content className="content-styles">
          <div className="header-image">
            <img
              src={HeaderOfUserManagement}
              alt="user management"
              style={{ width: "100%" }}
            />
          </div>
          <Form
            form={form}
            className="survey-form-user-management"
            layout="vertical"
            initialValues={{
              gender: "",
              country: "",
              language: "",
              workspace: "",
              role: "",
            }}
          >
            <div className="card">
              <div className="title-button">
                <h2>{t("membersList.title")}</h2>
                {normalizeRole(userRole) !== "viewer" && (
                  <div className="reset-filters-button">
                    <GeneralButton
                      variant="default"
                      className="button-style"
                      onClick={showModalForCreate}
                    >
                      <PlusOutlined /> {t("membersList.addMember")}
                    </GeneralButton>
                  </div>
                )}
              </div>
              <p>{t("membersList.description")}</p>
              <div className="searchManagerCountry-section">
                <div className="searchManagerCity-innerSection">
                  <div className="search-part-formembers">
                    <Form.Item
                      name="search"
                      label={t("membersList.searchLabel")}
                      className="title-filter-style search-label-style"
                    >
                      <Search
                        placeholder={t("membersList.searchPlaceholder")}
                        onSearch={(value) => setSearch(value)}
                        enterButton
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="search-input-style"
                        allowClear
                      />
                    </Form.Item>
                  </div>
                  <div className="buttons">
                    <Button
                      className="clear-all-buttonStyle"
                      onClick={clearAllFilters}
                    >
                      {t("membersList.clearAll")}
                    </Button>

                    <Button
                      className="hide-all-buttonStyle"
                      onClick={handleHideFilters}
                      icon={showFilters ? <UpOutlined /> : <DownOutlined />}
                    >
                      {showFilters
                        ? t("membersList.hideFilters")
                        : t("membersList.showFilters")}
                    </Button>
                  </div>
                </div>
                {showFilters && (
                  <>
                    <div className="searchManagerCity-innerSection g-c">
                      <div className="mananger-part">
                        <Form.Item
                          name="gender"
                          label={t("membersList.filters.genderLabel")}
                          className="title-filter-style"
                        >
                          <Select
                            showSearch
                            placeholder={t(
                              "membersList.filters.genderPlaceholder",
                            )}
                            optionFilterProp="children"
                            filterOption={(input: any, option: any) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={(value: any) => {
                              setSelectedGender(value);
                              fetchData(search, value);
                            }}
                            allowClear
                            className="gender-select-style"
                          >
                            {genders?.map((gender: any) => (
                              <Option key={gender.id} value={gender.id}>
                                {gender.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className="country-part-formembers">
                        <Form.Item
                          name="country"
                          label={t("membersList.filters.countryLabel")}
                          className="title-filter-style"
                        >
                          <Select
                            showSearch
                            placeholder={t(
                              "membersList.filters.countryPlaceholder",
                            )}
                            optionFilterProp="children"
                            filterOption={(input: any, option: any) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={(value: any) => {
                              setSelectedCountry(value);
                              form.setFieldsValue({ country: value });
                              fetchData(search, selectedGender, value);
                            }}
                            allowClear
                            className="country-select-style"
                          >
                            {countries.map((country: any) => (
                              <Option key={country.id} value={country.id}>
                                {country.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className="country-part-formembers">
                        <Form.Item
                          name="language"
                          label={t("membersList.filters.languageLabel")}
                          className="title-filter-style"
                        >
                          <Select
                            showSearch
                            placeholder={t(
                              "membersList.filters.languagePlaceholder",
                            )}
                            optionFilterProp="children"
                            filterOption={(input: any, option: any) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={(value: any) => {
                              setSelectedLanguage(value);
                              fetchData(
                                search,
                                selectedGender,
                                selectedCountry,
                                value
                              );
                            }}
                            allowClear
                            className="language-select-style"
                          >
                            {languages.map((language: any) => (
                              <Option key={language.id} value={language.id}>
                                {language.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="searchWorkspaceRole-innerSection">
                      <div className="mananger-part">
                        <Form.Item
                          name="workspace"
                          label={t("membersList.filters.workspaceLabel")}
                          className="title-filter-style"
                          style={{ marginBottom: "unset" }}
                        >
                          <Select
                            showSearch
                            placeholder={t(
                              "membersList.filters.workspacePlaceholder",
                            )}
                            optionFilterProp="children"
                            filterOption={(input: any, option: any) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={(value: any) => {
                              setSelectedWorkspace(value);
                              fetchData(
                                search,
                                selectedGender,
                                selectedCountry,
                                selectedLanguage,
                                value
                              );
                            }}
                            allowClear
                          >
                            {workspaces?.map((workspace: any) => (
                              <Option key={workspace.id} value={workspace.id}>
                                {workspace.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className="country-part-formembers">
                        <Form.Item
                          name="role"
                          label={t("membersList.filters.roleLabel")}
                          className="title-filter-style"
                          style={{ marginBottom: "unset" }}
                        >
                          <Select
                            showSearch
                            placeholder={t(
                              "membersList.filters.rolePlaceholder",
                            )}
                            optionFilterProp="children"
                            filterOption={(input: any, option: any) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={(value: any) => {
                              setSelectedRole(value);
                              fetchData(
                                search,
                                selectedGender,
                                selectedCountry,
                                selectedLanguage,
                                selectedWorkspace,
                                value
                              );
                            }}
                            allowClear
                          >
                            {roles.map((role: any) => (
                              <Option key={role.id} value={role.id}>
                                {role.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {errorInResponse ? (
                <Typography.Text
                  type="danger"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  {errorInResponse}
                </Typography.Text>
              ) : (
                <GenericTable<DataType>
                  rowSelection={{
                    type: selectionType,
                    ...rowSelection,
                  }}
                  columns={columns}
                  dataSource={filteredData}
                  loading={loading}
                  className="member-list-table"
                  emptyText={t("membersList.emptyText")}
                />
              )}
            </div>
          </Form>
        </Content>
        <MemberModal
          visible={isModalVisible}
          onCancel={handleModalClose}
          onCreate={handleCreate}
          memberId={currentMemberId}
          mode={modalMode}
        />
      </div>
    </>
  );
}

export default MembersList;
